import React, { FC } from 'react'
import { Col, Row } from '../../../../../../ui/atoms/Grid'
import { BtText } from '@linqpal/components/src/ui'
import { OwnerReviewStyles as styles } from './OwnerReviewStyles'
import { SecureLabel } from '@linqpal/components/src/ui/BtSecureLabel'

interface OwnerPropertyRowProps {
  label: string
  value: string
  secured?: boolean
}

export const OwnerPropertyRow: FC<OwnerPropertyRowProps> = ({
  label,
  value,
  secured = false,
}) => {
  return (
    <Row>
      <Col style={{ flex: 1 }}>
        <BtText weight={500} style={styles.propertyText}>
          {label}
        </BtText>
      </Col>
      <Col style={{ flex: 2 }}>
        {secured ? (
          <SecureLabel value={value} />
        ) : (
          <BtText weight={700} style={{ lineHeight: 26 }}>
            {value}
          </BtText>
        )}
      </Col>
    </Row>
  )
}
